export const buildUnleashUserId = (
    contactId: string,
): string => {
  return `admin_${contactId}`;
};
